import React from "react"
import {
	Paper,
	Grow,
	Box,
	Icon,
	Typography,
	makeStyles,
	Button,
	CardActionArea,
} from "@material-ui/core/"
import { Link as RouterLink } from "react-router-dom"
import { useTranslation } from "react-i18next"

const useStyles = makeStyles((theme) => ({
	whiteFill: {
		fill: "#ffffff",
	},
	yellowBtn: {
		color: theme.palette.greenDark.main,
		backgroundColor: theme.palette.yellow.main,
		"&:hover": {
			backgroundColor: theme.palette.yellow.dark,
			"@media (hover: none)": {
				backgroundColor: theme.palette.yellow.main,
			},
		},
	},
	tileDark: {
		textAlign: "center",
		color: "#ffffff",
		background: theme.palette.greenDark.main,
		borderRadius: "4px",
		height: "100%",
		boxShadow:
			"0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
	},
	tile: {
		textAlign: "center",
		color: "#ffffff",
		background: theme.palette.primary.main,
		borderRadius: "4px",
		height: "100%",
		boxShadow:
			"0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
	},
	tilelink: {
		color: "#ffffff",
		textDecoration: "none !important",
	},
	tiletext: { fontSize: 15 },
}))

const CalcCard = ({ content, title, url, icon }) => {
	const classes = useStyles()
	const { t, i18n } = useTranslation()
	const lang = i18n.language == "en" ? "" : "/nl"
	return (
		<CardActionArea className={classes.tile} component="button">
			<Box p={1} py={3}>
				<Typography variant="h3" component="h3">
					{title}
				</Typography>
				<Box>{icon}</Box>
				<Box display={{ xs: "none", sm: "block" }}>
					<Typography
						variant="body1"
						className={classes.tiletext}
						component="p"
						gutterBottom
					>
						{content}
					</Typography>
				</Box>
				<Button
					component={RouterLink}
					to={`${lang}${url}`}
					size="large"
					variant="contained"
					className={classes.yellowBtn}
				>
					{t("home.gotocalculator")}
				</Button>
			</Box>
		</CardActionArea>
	)
}
export default CalcCard
